import { useEffect, useState } from "react";
import axios from "axios";
import MembershipForm from "./MembershipForm";

function MembershipRequests() {
  const [requests, setRequests] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(false)
  const [editingRequest, setEditingRequest] = useState(null);

  const fetchRequests = async () => {
    try {
      const res = await axios.get("https://uxzsrd33be23alhtpfmy5ziuc40vnldo.lambda-url.us-east-1.on.aws/memberships");
      setRequests(res.data);
    } catch (err) {
      console.error("Error fetching memberships:", err);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const res = await axios.get("https://uxzsrd33be23alhtpfmy5ziuc40vnldo.lambda-url.us-east-1.on.aws/memberships");
        setRequests(res.data);
      } catch (err) {
        console.error("Error fetching membership requests:", err);
      }
    };
    fetchRequests();
  }, []);

  const updateStatus = async (membershipId, status) => {
    try {
      await axios.put(`https://uxzsrd33be23alhtpfmy5ziuc40vnldo.lambda-url.us-east-1.on.aws/memberships/${membershipId}`, {
        paymentStatus: status, // "accepted" or "rejected"
      });
      setRequests((prev) =>
        prev.map((r) =>
          r.membershipId === membershipId ? { ...r, paymentStatus: status } : r
        )
      );
    } catch (err) {
      console.error("Error updating payment status:", err);
    } finally {
        await fetchRequests();
    }
  };

  function formatDate(dateStr) {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  }

  useEffect(() => {
    fetchRequests();
  }, [refreshTrigger]);

  const refreshList = () => {
    setRefreshTrigger(!refreshTrigger);
  }

  return (
    <div className="space-y-4">
      
      {editingRequest && (
        <div className="bg-white shadow p-4 rounded-xl border border-gray-200">
          <h2 className="text-xl font-bold mb-2">Edit Membership</h2>
          <MembershipForm
            initialValues={editingRequest}
            onSuccess={() => {
              setEditingRequest(null);
              refreshList();
            }}
          />
          <button
            onClick={() => setEditingRequest(null)}
            className="text-sm text-gray-600 mt-2"
          >
            Cancel
          </button>
        </div>
      )}

      {requests.map((req) => (
        <div key={req.membershipId} className="bg-white shadow p-4 rounded-xl border border-gray-200 space-y-2">
          <p><strong>👤 User Name:</strong> {req.userName}</p>
          <p><strong>📋 Plan Name:</strong> {req.planName}</p>
          <p><strong>🕒 Slot:</strong> {req.slot}</p>
          <p><strong>📅 Submit Date:</strong> {formatDate(req.submitDate)}</p>
          <p><strong>📆 Join Date:</strong> {formatDate(req.joiningDate)}</p>
          <p><strong>⏳ Due Date:</strong> {formatDate(req.dueDate)}</p>
          <p><strong>🧾 Payment Screenshot:</strong> <a href={req.paymentURL} className="text-blue-600 underline" target="_blank" rel="noreferrer">View</a></p>
          <p>
            <strong>✅ Status:</strong>{" "}
            {req.paymentStatus === "accepted" ? (
              <span className="text-green-600">Accepted</span>
            ) : req.paymentStatus === "rejected" ? (
              <span className="text-red-600">Rejected</span>
            ) : (
              <span className="text-yellow-600">Pending</span>
            )}
          </p>
          {req.paymentStatus === "pending" && (
            <div className="flex gap-2 pt-2">
              <button
                onClick={() => updateStatus(req.membershipId, "accepted")}
                className="bg-green-600 text-white px-4 py-2 rounded"
              >
                Approve
              </button>
              <button
                onClick={() => updateStatus(req.membershipId, "rejected")}
                className="bg-red-600 text-white px-4 py-2 rounded"
              >
                Reject
              </button>
            </div>
          )}
            <div>
              <button
                onClick={() => setEditingRequest(req)}
                className="bg-blue-300 text-white px-4 py-2 rounded"
              >
                Edit
              </button>
            </div>
        </div>
      ))}
    </div>
  );  
}

export default MembershipRequests;
